import { render, staticRenderFns } from "./pklist.vue?vue&type=template&id=2f364f95&scoped=true"
import script from "./pklist.vue?vue&type=script&lang=js"
export * from "./pklist.vue?vue&type=script&lang=js"
import style0 from "./pklist.vue?vue&type=style&index=0&id=2f364f95&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f364f95",
  null
  
)

export default component.exports